import { Node, mergeAttributes } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-3'
import InlineArtifactChip from '@/components/wysiwyg-components/nodes/artifact/inline/InlineArtifactChip.vue'

export default Node.create({
  name: 'inline-artifact',
  group: 'inline',
  inline: true,
  atom: true,

  addAttributes() {
    return {
      artifactId: {
        default: null,
        parseHTML: element => element.getAttribute('artifact-id'),
        renderHTML: attributes => ({ 'artifact-id': attributes.artifactId }),
      },
    }
  },

  parseHTML() {
    return [{ tag: 'inline-artifact' }]
  },

  renderHTML({ HTMLAttributes }) {
    return ['inline-artifact', mergeAttributes(HTMLAttributes)]
  },

  addNodeView() {
    return VueNodeViewRenderer(InlineArtifactChip)
  },
})
